
import Vue from 'vue';
import { faSparkles } from '@delfi.lt/fa-kit/icons/modules/classic/light';

export default Vue.extend<unknown, unknown, unknown, unknown>({
  data() {
    return {
      faSparkles,
    };
  },
});
